import { Link } from 'react-router-dom';
import IMAGES from '../images';
import './CollectionPage.css';

// Generic product grid page
export function CollectionPage({ title, label, description, products }) {
  return (
    <main className="cpage">
      {/* Hero Banner */}
      <div className="cpage__banner">
        <img src={products[0]?.img} alt={title} className="cpage__banner-img" />
        <div className="cpage__banner-overlay" />
        <div className="cpage__banner-content">
          <span className="section-label">{label}</span>
          <h1 className="cpage__banner-title">{title}</h1>
          <div className="cpage__banner-divider" />
          {description && <p className="cpage__banner-desc">{description}</p>}
        </div>
      </div>

      {/* Grid */}
      <section className="cpage__grid-section">
        <div className="cpage__grid">
          {products.map((p, i) => (
            <div key={i} className="cpage__card">
              <div className="cpage__card-img-wrap">
                <img src={p.img} alt={p.name} className="cpage__card-img" />
              </div>
              <div className="cpage__card-info">
                {p.collection && <span className="cpage__card-collection">{p.collection}</span>}
                <h3 className="cpage__card-name">{p.name}</h3>
                {p.material && <p className="cpage__card-material">{p.material}</p>}
                <a href="mailto:yazidi.khansa@gmail.com?subject=Demande%20de%20Devis" className="cpage__card-btn">
                  Demander un Devis
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Strip */}
      <div className="cpage__cta-strip">
        <p>Une création sur mesure ? Contactez-nous pour un projet personnalisé.</p>
        <Link to="/contact" className="btn-outline">Nous Contacter</Link>
      </div>
    </main>
  );
}

// ─── Robinetterie ────────────────────────────────────────────
export function Robinetterie() {
  const products = [
    { img: IMAGES.douches,       name: 'Collection Douches',        material: 'Laiton Massif Poli', collection: 'Douches' },
    { img: IMAGES.robinetsPoser, name: 'Robinets À Poser',          material: 'Laiton Massif Doré', collection: 'À Poser' },
    { img: IMAGES.robinetsMuraux, name: 'Robinets Muraux',          material: 'Laiton Massif Noir', collection: 'Muraux' },
    { img: IMAGES.douches,       name: 'Robinet Suspendu Leaf',     material: 'Laiton Massif Chrome', collection: 'Leaf' },
    { img: IMAGES.robinetsPoser, name: 'Mitigeur Vasque Or Rose',   material: 'Laiton Massif Rosé', collection: 'À Poser' },
    { img: IMAGES.robinetsMuraux, name: 'Colonne de Douche Hammam', material: 'Laiton Massif Cuivré', collection: 'Douches' },
  ];
  return (
    <CollectionPage
      title="Robinetterie"
      label="Savoir-faire Artisanal"
      description="Chaque robinet est façonné à la main en laiton massif, alliant robustesse et élégance intemporelle."
      products={products}
    />
  );
}

// ─── Vasques ─────────────────────────────────────────────────
export function Vasques() {
  const products = [
    { img: IMAGES.vasquesMarbre,    name: 'Vasque Marbre Blanc',    material: 'Marbre de Carrare', collection: 'Marbre' },
    { img: IMAGES.vasquesLaiton,    name: 'Vasque Laiton Martelé',  material: 'Laiton Martelé à la Main', collection: 'Laiton' },
    { img: IMAGES.vasquesCeramique, name: 'Vasque Céramique Mate',  material: 'Céramique Émaillée', collection: 'Céramique' },
    { img: IMAGES.vasquesMarbre,    name: 'Vasque Marbre Noir',     material: 'Marbre Noir Tunisien', collection: 'Marbre' },
    { img: IMAGES.vasquesLaiton,    name: 'Vasque Cuivre Vieilli',  material: 'Cuivre Patiné', collection: 'Laiton' },
    { img: IMAGES.vasquesCeramique, name: 'Vasque Céramique Olea',  material: 'Céramique Collection Olea', collection: 'Céramique' },
  ];
  return (
    <CollectionPage
      title="Vasques"
      label="Matières Nobles"
      description="Sculptées dans les plus belles matières, nos vasques transforment chaque salle de bain en espace d'exception."
      products={products}
    />
  );
}

// ─── Accessoires ─────────────────────────────────────────────
export function Accessoires() {
  const products = [
    { img: IMAGES.robinetsMuraux,   name: 'Porte-Savon Laiton',       material: 'Laiton Massif Doré', collection: 'Porte-Savons' },
    { img: IMAGES.robinetsPoser,    name: 'Porte-Serviettes Mural',    material: 'Laiton Massif Noir', collection: 'Porte-Serviettes' },
    { img: IMAGES.douches,          name: 'Porte-Brosse à Dents',      material: 'Laiton Poli', collection: 'Porte-Brosses' },
    { img: IMAGES.vasquesCeramique, name: 'Miroir Cadre Laiton',       material: 'Laiton & Verre', collection: 'Miroirs' },
    { img: IMAGES.vasquesMarbre,    name: 'Bougeoir Marbre & Laiton',  material: 'Marbre & Laiton', collection: 'Bougeoirs' },
    { img: IMAGES.vasquesLaiton,    name: 'Papier Toilette Laiton',    material: 'Laiton Massif Doré', collection: 'Papier Toilette' },
  ];
  return (
    <CollectionPage
      title="Accessoires"
      label="Compléments d'Excellence"
      description="Des accessoires de salle de bain pensés dans la continuité de nos collections, pour une cohérence absolue."
      products={products}
    />
  );
}

// ─── Collection Héritage ──────────────────────────────────────
export function CollectionHeritage() {
  const products = [
    { img: IMAGES.collectionOlea,   name: 'Robinet Olea Or',     material: 'Laiton Doré à l\'or 24k', collection: 'Olea Aurea' },
    { img: IMAGES.vasquesMarbre,    name: 'Vasque Olea Marbre',  material: 'Marbre Blanc & Laiton', collection: 'Olea Aurea' },
    { img: IMAGES.collectionDeesse, name: 'Collection Déesse',   material: 'Laiton Massif Rose', collection: 'Déesse' },
    { img: IMAGES.designer,         name: 'Miroir Héritage',     material: 'Laiton Patiné & Bois', collection: 'Héritage' },
  ];
  return (
    <CollectionPage
      title="Collection Héritage"
      label="Nouvelle Collection 2024"
      description="Olea Aurea — L'or de l'olivier. Une collection inspirée de la nature tunisienne, façonnée en laiton doré à l'or 24 carats."
      products={products}
    />
  );
}
